      <div class="modal-content">
        <div class="modal-header header">
          <h5 class="modal-title w-100" [translate]="this.title"></h5>
          <button type="button" class="close pull-right modal-close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pt-0 lite-modal m-2">
            <div class="d-flex justify-content-between align-items-center mt-2">
                <div class="d-flex">
                    <img src="assets/images/checklists/checklist.svg" class="mr-1 logo" width="25" height="30">
                    <h3>{{ Localization.Checkpoint | translate}}</h3>
                </div>
            </div>
            <div class="mt-2">
                <ng-container *ngIf="!loading; else loadingView">
                    <chapps-select-input
                        [items]="checkpointOptions"
                        [placeholder]="Localization.Select"
                        [control]="selectionField">
                    </chapps-select-input>
                </ng-container>
            </div>
        </div>
        <div class="modal-footer justify-content-end">
          <chapps-secondary-button
              [label]="Localization.Proceed"
              [small]="true"
              (clicked)="onSubmit()">
          </chapps-secondary-button>
        </div>
      </div>

      <ng-template #loadingView>
          <mdb-spinner
                       spinnerColor="blue" ></mdb-spinner>
      </ng-template>